import { OrderService } from './../../Services/order.service';
import { ClothesService } from './../../Services/clothes.service';
import { Component, OnInit, Input, EventEmitter, Output, AfterViewInit, SimpleChanges } from '@angular/core';
import Swal from 'sweetalert2';
import * as $ from 'jquery';
import { ThrowStmt } from '@angular/compiler';
import { AuthService } from '../../Services/auth.service';
import { Router } from '@angular/router';
import { PaymentService } from '../../Services/payment.service';

@Component({
  selector: 'app-clothes-admin-list',
  template: require('./clothes-admin-list.component.html'),
  styles: [require('./clothes-admin-list.component.css')]
})
export class ClothesAdminListComponent implements AfterViewInit {
  @Input('ordering') ordering: boolean = false;
  @Input('current_member') current_member: any = {};
  @Input('noAdmin') noAdmin: boolean=false;
  @Output() clearMemberEvent = new EventEmitter<number>();
  
  constructor(
    private clothesService: ClothesService, 
    private orderService: OrderService, 
    private paymentService: PaymentService,
    private auth: AuthService,
    private router: Router) { 

      (window as any).Swal = Swal;

    }
    
  all_clothes: any[] = [];
  all_clothesSizes: any[] = [];
  selected_clothes: any[] = [];
  cart :any ={
    items: [],
    total_price: 0,
    total_amount: 0
  } 

  cartItems = [];
  showMaleOnly = false;
  showFemaleOnly = false;
  showAll = true;
  isOpen = false;
  memberDiscount: any ={
    amountClothesLeft: 0.0,

  }
  errorMessage = "";

  ngAfterViewInit() {
    if (this.ordering){
      this.orderService.getCurrentopenOrder().subscribe( x =>{
        if (x.status == 200){
          this.isOpen = true;
          this.loadAllClothes();
          this.loadAllClothesSizes();
        } else{
          this.isOpen = false;
        }
      })
    }else{
      setTimeout(() => {
        this.loadAllClothes();
        this.loadAllClothesSizes();
        this.isOpen = true;
      }, 500);
    }

  }

  //Watch for changes on @Input
  ngOnChanges(changes: SimpleChanges) {
    if (changes['current_member']) {
      this.getDiscountLeft();
    }
  }

  loadAllClothes(){
    this.clothesService.getAllClothes(!this.ordering).subscribe( x => {
      this.all_clothes = x;
      this.selected_clothes = this.all_clothes;      
    })
  }

  loadAllClothesSizes(){
      this.clothesService.getClothesAllSizes().subscribe( x=>{
        this.all_clothesSizes = x;
      })
  }

  getDiscountLeft(){   
    if (this.current_member.id > -1){
      this.orderService.getDiscountLeftForId(this.current_member.id).subscribe( x =>{
        if (x.status == 200){
          this.memberDiscount = x.value;
        }
      });
    }else {
      this.memberDiscount = {
          amountClothesLeft: 0.0,
      }
    }
  }

  loadSelectedClothes(){
    // if (this.showFemaleOnly || this.showMaleOnly){
    //   this.selected_clothes = this.all_clothes.filter( a => ( (a.isMale == this.showMaleOnly) && (a.isFemale == this.showFemaleOnly) ) ) ;
    // }

    // Unisex does not show in filtered results

    if (this.showMaleOnly){
      this.selected_clothes = this.all_clothes.filter( a => ( a.isMale == this.showMaleOnly  ) ) ;
    }else if(this.showFemaleOnly){
      this.selected_clothes = this.all_clothes.filter( a=> (a.isFemale == this.showFemaleOnly));
    }

    else{
      this.selected_clothes = this.all_clothes;
    }
  }

  delete(id:number){
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je dit wil verwijderen?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.clothesService.delete(id).subscribe( x => {
          this.loadAllClothes();
        })
      }
    });
  }

  calculateTotalPrice(){
    var total = 0
    var amount = 0
    this.cart.items.forEach( (i:any) => {
      total += (i.item.price * i.amount);
      amount += parseInt(i.amount);
    });
    this.cart.total_price = total;
    this.cart.total_amount = amount;
   
  }

  getClothesSizesForId(id:number, clothesID:boolean = true ):any[] {
    if (clothesID){
      return this.all_clothesSizes.filter( cs => {
        return cs.clothesId === id
      })
    }else{
      return this.all_clothesSizes.filter( cs => {
        return cs.id === id
      })
    }
  }

  addToCart(item: any){
    var res = this.getClothesSizesForId(item.id)

    var options: string = "";
    res.forEach( (el:any)=>{
      options += `<option value="${ el.id }">${ el.size }</option>`
    });


    var innerhtml = `
        <div style="text-align:left">
          <div class="row mt-4">
            <div class="col col-lg-4">
              <label class="control-label" for="ClothingSize">Maat:</label>
            </div>
            <div class="col col-lg-10">
              <select id="ClothingSize" class="form-control"  name="ClothingSize" required>
                ${options}
              </select>
            </div>
          </div>
          <div class="row mt-4">
          <div class="col col-lg-4">
            <label class="control-label" for="ClothingAmount">Hoeveel:</label>
          </div>
          <div class="col col-lg-10">
            <input class="form-control" type="number" id="ClothingAmount" value="1" min="1">
          </div>
        </div>
      </div>
  `

    Swal.fire({
      title: 'Welke maat en hoeveelheid',
      html: innerhtml,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Bestellen',
      cancelButtonText: 'Annuleren',
      preConfirm: function(result){
          if (result){
            var ClothingSizeId =  parseInt((<HTMLInputElement>document.getElementById('ClothingSize')).value as string);
            var ClothingAmount =  parseInt((<HTMLInputElement>document.getElementById('ClothingAmount')).value as string);
            
            return {ClothingSizeId:ClothingSizeId, ClothingAmount:ClothingAmount }

          }
        }
      }).then( (result:any) => {
        if (result.value){
  
          var sizeText = this.getClothesSizesForId(result.value.ClothingSizeId, false)[0];
         
          this.cart.items.push( {item:item, amount: result.value.ClothingAmount, sizeid: result.value.ClothingSizeId, size: sizeText.size} );
          this.calculateTotalPrice();
        }
      })
  }

  deleteFromCart(id: number){
    Swal.fire({
      title: 'Ben je zeker?',
      text: "Ben je zeker dat je dit wil verwijderen?",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        const index = this.cart.items.findIndex((d:any) => d.item.id === id);
        console.log("index to delete: ",index);
        console.log("ID to search: ",id);
        
        
        if (index > -1) {
          this.cart.items.splice(index, 1);
        }
        this.checkOrder();
        this.calculateTotalPrice();
      }
    });
  }

  amountChanged(id:number, amount:number){
    const index = this.cart.items.findIndex( (d:any) => d.item.id == id );
    this.cart.items[index].amount = amount;   
    this.calculateTotalPrice();
  }

  // 
  sizeChanged(id:number, sizeId:string){
    const index = this.cart.items.findIndex( (d:any) => d.item.id == id );
    const sizeText = 
    this.cart.items[index].sizeid = sizeId;   
    this.cart.items[index].size = (this.getClothesSizesForId(parseInt(sizeId), false)[0]).size;   
  }

  selectMale(){
    this.showFemaleOnly = false;
    this.showMaleOnly = true;
    this.loadSelectedClothes();
  }

  selectFemale(){
    this.showFemaleOnly = true;
    this.showMaleOnly = false;
    this.loadSelectedClothes();
  }
  selectAll() {
    this.showFemaleOnly = false;
    this.showMaleOnly = false;
    this.showAll = true;
    this.loadSelectedClothes();
  }

  makeid(length:number) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
   return result;
  }

  showSummary(){
    var innerhtml = `
            <table class="table table-image mt-5">
            <thead>
              <tr>
                <th scope="col">Titel</th>
                <th scope="col">Maat</th>
                <th scope="col">aantal</th>
                <th scope="col">Prijs</th>
                <th scope="col">Total</th>
              </tr>
            </thead>
            <tbody>`
    
        this.cart.items.forEach((i:any) => {
        innerhtml += `
              <tr>
                <td class="text-right">
                  ${i.item.title}
              `
              if (i.item.isMale) {
                innerhtml += '<i class="fa fa-mars mr-2" style="font-size: 12pt; font-weight: bold;" aria-hidden="true"></i>'
              }

              if (i.item.isFemale){
                innerhtml += '<i class="fa fa-venus" style="font-size: 12pt; font-weight: bold;" aria-hidden="true"></i>'
              }
        innerhtml += `</td>
                        <td>${i.size}</td>
                        <td class="qty">${i.amount}</td>
                        <td>${i.item.price}</td>
                        <td>${i.amount  * i.item.price}</td>
                     </tr>
                   `
        });
        

        // TODO: packageingcost!
        var discount = 0;
        
        var toPay = 0;
        if ( this.memberDiscount.amountClothesLeft > this.cart.total_price) {
          discount = this.cart.total_price;
          toPay = 0;
        } else {
          discount = this.memberDiscount.amountClothesLeft
          toPay = this.cart.total_price - discount;
        }
        

        innerhtml += `
              </tbody> 
            </table> 
            <div class="d-flex justify-content-end">
              <div style="width: 320px;">
                <div class="row p-1 justify-content-end">
                  <div class="col col-lg-6 text-right mr-0">Total:</div>
                  <div class="col col-lg-4"><span class="price text-danger">${this.cart.total_price} &euro;</span></div>
                </div>
                <div class="row p-1 justify-content-end">
                  <div class="col col-lg-6 text-right">Korting:</div>
                  <div class="col col-lg-4"><span class="price text-success">${discount} &euro;</span></div>
                </div>

                <div class="row p-1 justify-content-end">
                  <div class="col col-lg-6 text-right">Te Betalen:</div>
                  <div class="col col-lg-4"><span class="price text-success">${toPay} &euro;</span></div>
                </div>
              </div>
              <!--
              <h5>Total: <span class="price text-success">${this.cart.total_price}</span></h5>
              <h5>Korting: <span class="price text-success">${this.memberDiscount.amountClothesLeft}</span></h5>
              <h5>Te Betalen: <span class="price text-success">${this.cart.total_price - this.memberDiscount.amountClothesLeft}</span></h5>
              -->
            </div>
            
           

            <div class="text-left mt-5">
              <h5> Ben je zeker van de bestelling? </h5>
            </div>
        `
    Swal.fire({
      title: "Samenvatting van de bestelling",
      html: innerhtml,
      width: '800px',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Jep',
      cancelButtonText: 'Nope'
    }).then((result) => {
      if (result.value) {
        this.CheckoutOrder();
      }
    });;
  }

  CheckoutOrder(){   
    var cartID = this.makeid(15);

    var items: any[] = [];

    this.cart.items.forEach( (i:any) => {
      console.log(i);
      
      var item = {
        itemId: i.item.id,
        amount: i.amount,
        size: i.size,
        sizeid: i.sizeid
        //cartID: cartID
      }
      items.push(item);
    });
    var order = {
      items: items,
      memberId: this.current_member.id
    }
    
    this.orderService.addItemsToCurrentOrder(order).subscribe( x =>{
      var paymentMetaData ={
        "Id": -1,
        "Category": "clothespayment",
        "idString": x.cartId
      }
      this.paymentService.CreatePaymentLink(paymentMetaData).subscribe( res => {
        console.log("Link: -->");       
        console.log(res)
        var link = ""
        if (res.status == 200){
          link = res.value.url;
        }
        this.PaymentSummary(x.totalPrice, x.cartId, x.name, link)
      })
    });    
  }



  PaymentSummary(amount:number, cartId:string, name:string, paymentlink: string){
    var innerhtml = `
    <div class="text-left mt-5">
      De bestelling is geplaatst maar is pas volledig na de betaling van <strong>${amount}&euro;</strong> via<br>
      <div class="mt-5">
        <div class="mt-2 mb-2">Overschrijving:</div>
        Rekening nummer: <strong>BE27-2300-2175-2773</strong><br>
        Mededeling: <strong>KLEDIJ-${name}-${cartId}</strong>
      </div>
      <br>
      Deze gegevens ontvangt u ook nog per email

    
    `
    if (paymentlink.length > 0){
      innerhtml +=`
      <br><br>
      of gebruik onderstaande link om dadelijk te betalen via Bancontact: <br><br>

      <a href="${paymentlink}" target="_blank" onclick="Swal.closeModal();"><img width='100' style='border: 1px solid black;' src='https://www.wringers-bertem.be/assets/images/bancontact/Bancontact.png' alt='bancontactlink'></a>

      `
    }

    innerhtml +="</div>"

    // <div class="mt-5 mb-5 text-left"> of </div>

    // <div class="mt-5">
    // <div class="mt-2 mb-2">Payconiq:</div>
    //   <div>Mededeling: <strong>KLEDIJ-${name}-${cartId}</strong></div>
    //   <img src="/assets/images/payconiq/qrcode.png" width="250px">
    // </div>

    Swal.fire({
      title: "Samenvatting van de bestelling.",
      html: innerhtml,
      width: '800px',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'ok',
    }).then( (result) => {
        this.clearMemberEvent.emit(this.current_member.id);
        if (!this.auth.isInRole('admin') || this.noAdmin ) {
          this.router.navigate(['/home']);
        }
    })
  }

  clearCart(){
    this.cart ={
      items: [],
      total_price: 0,
    } 
  }

  private checkOrder(){    
    this.errorMessage = "";
    
    if (this.current_member.gender != null ){
      switch (this.current_member.gender.toLowerCase()) {
        case 'm':
          this.cart.items.forEach( (ci:any) => {   
            if ((ci.item.isFemale) && (!ci.item.isMale)) {
              this.errorMessage = "Je besteld ook vrouwen kledij..."
            }
          });
          break;
        case 'v':
          this.cart.items.forEach( (ci:any) => {         
            if ((ci.item.isMale)&& (!ci.item.isFemale)){
              this.errorMessage = "Je besteld ook mannen kledij..."
            }
          });
          break
        default:
          break;
      }    
    }
  }


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/clothes-admin-list/clothes-admin-list.component.ts